import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { SchoolAdminService } from "../services/schooladmin.service";
import { AddTriggerComponent } from "./add-trigger/add-trigger.component";
import { ViewTriggerComponent } from "./view-trigger/view-trigger.component";

@Component({
	selector: "app-triggers",
	templateUrl: "./triggers.component.html",
	styleUrls: ["./triggers.component.css"],
})
export class TriggersComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private schoolAdminService: SchoolAdminService,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		// this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	///////////////////////////////
	// Data
	///////////////////////////////

	subscription: any;

	//Input Data
	SelectedSchoolID: any = 0;
	lstSchool: any = [];

	//Misc
	errorMessage: any = "";
	triggerCount: Number = 0;

	//Table Data
	pagerows: any = 10;
	pagefirst: any = 0;
	SelectedTrigger: any = null;

	cols = [
		{ field: "ActionTriggerType", header: "Action Trigger Type" },
		{ field: "TriggeredFor", header: "Triggered For" },
		{ field: "ActionType", header: "Action Type" },
		{ field: "Action", header: "Action" },
		{ field: "TriggerValue", header: "Trigger Value" },
		{ field: "Active", header: "Active" },
	];

	//Data from DB
	RawTriggerList: any = [];

	//Formatted Lists
	lstTriggers: any = [];

	//Filter lists
	lstActionTriggerType: any = [];
	lstTriggeredFor: any = [];
	lstActionType: any = [];
	lstAction: any = [];

	lstActive: any = [];

	loading: any = false;

	///////////////////////////////

	///////////////////////////////
	// Load Data
	///////////////////////////////
	private loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.SelectedSchoolID = this.lstSchool[0].SchoolID;

				this.loadActionTriggerlist();
			},
			(error) => {}
		);
	}

	private loadActionTriggerlist() {
		this.loading = true;

		var result = this.schoolAdminService.ActionTriggerSelectList("", this.SelectedSchoolID, 2);
		result.subscribe(
			(response) => {
				this.RawTriggerList = response;

				this.UpdateTable();
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	UpdateTable() {
		this.lstTriggers = [];

		for (var i = 0; i < this.RawTriggerList.length; i++) {
			var next = this.RawTriggerList[i];

			var active = next.Active == 1 ? "Yes" : "No";

			let val1: any = {
				ActionTriggerID: next.ActionTriggerID,
				ActionTriggerType: next.ActionTriggerTypeDesc,
				TriggeredFor: next.TriggeredFor,
				ActionType: next.ActionType,
				Action: next.ActionFirst,
				TriggerValue: next.Count,
				Active: active,
			};

			this.lstTriggers = [...this.lstTriggers, val1];

			//Updating Dropdowns:
			this.lstActionTriggerType = Array.from(new Set(this.lstTriggers.map((item: any) => item.ActionTriggerType))).sort();
			this.lstTriggeredFor = Array.from(new Set(this.lstTriggers.map((item: any) => item.TriggeredFor))).sort();
			this.lstActionType = Array.from(new Set(this.lstTriggers.map((item: any) => item.ActionType))).sort();
			this.lstAction = Array.from(new Set(this.lstTriggers.map((item: any) => item.Action))).sort();

			this.lstActive = Array.from(new Set(this.lstTriggers.map((item: any) => item.Active))).sort();
		}

		this.loading = false;
	}

	///////////////////////////////

	///////////////////////////////
	// Buttons
	///////////////////////////////
	onRefresh() {
		this.errorMessage = "";

		this.loadActionTriggerlist();
	}

	onAddTrigger() {
		this.errorMessage = "";

		//Create Popup
		var ref = this.dialogService.open(AddTriggerComponent, {
			header: "Add Trigger",
			width: "fit-content",
			data: {
				SchoolID: this.SelectedSchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadActionTriggerlist();
			}
		});
	}

	onRowDblClick(val) {
		this.SelectedTrigger = val;
		this.onViewDetails();
	}

	onViewDetails() {
		this.errorMessage = "";

		if (this.SelectedTrigger == null) {
			this.errorMessage = "Select a Trigger";
			return;
		}

		//Create Popup
		var ref = this.dialogService.open(ViewTriggerComponent, {
			header: "View Trigger",
			width: "fit-content",
			data: {
				SelectedTrigger: this.SelectedTrigger,
			},
		});
		ref.onClose.subscribe((response) => {
			// if (response == 1)
			// {
			//   this.loadActionTriggerlist();
			// }
		});
	}

	onResetTrigger() {
		this.errorMessage = "";

		if (this.SelectedTrigger == null) {
			this.errorMessage = "Select a Trigger";
			return;
		}

		var result = this.schoolAdminService.ActionTriggerReset("", this.SelectedTrigger.ActionTriggerID);
		result.subscribe(
			(response) => {
				if (response) {
					this.SelectedTrigger = null;
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Trigger was reset",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadActionTriggerlist();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Reset Trigger",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onToggleTrigger() {
		this.errorMessage = "";

		if (this.SelectedTrigger == null) {
			this.errorMessage = "Select a Trigger";
			return;
		}

		var active: Number = this.SelectedTrigger.Active == "Yes" ? 0 : 1;

		var result = this.schoolAdminService.ActionTriggerToggle("", this.SelectedTrigger.ActionTriggerID, active, 1);
		result.subscribe(
			(response) => {
				if (response) {
					this.SelectedTrigger = null;
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Trigger was changed to " + (active == 1 ? "Active" : "Not Active"),
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadActionTriggerlist();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Toggle Trigger",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onRemoveTrigger() {
		this.errorMessage = "";

		if (this.SelectedTrigger == null) {
			this.errorMessage = "Select a Trigger to Delete";
			return;
		}

		var result = this.schoolAdminService.ActionTriggerRemove("", this.SelectedTrigger.ActionTriggerID, 1);
		result.subscribe(
			(response) => {
				if (response) {
					this.SelectedTrigger = null;
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Trigger was removed",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadActionTriggerlist();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Toggle Trigger",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	///////////////////////////////

	///////////////////////////////
	// Events
	///////////////////////////////
	onSchoolChange(val) {
		this.errorMessage = "";

		this.SelectedSchoolID = val;

		//Reload list of triggers
		this.loadActionTriggerlist();
	}

	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedTrigger = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedTrigger = null;
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	///////////////////////////////
}
